import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BanksID } from '@core/models';

@Component({
  selector: 'app-information-report-bank',
  templateUrl: './information-report-bank.component.html',
  styleUrls: ['./information-report-bank.component.scss'],
})
export class InformationReportBankComponent {
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<InformationReportBankComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: BanksID[],
  ) {}
  close(): void {
    this.dialogRef.close();
  }
}
